module.exports = __webpack_public_path__ + "static/media/logoMolina.7a9ab04b.png";